var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"animate"},[_c('sop-tile'),_c('template-tile'),_c('template-content-tile'),_c('applicability-tile'),_c('last-sops-tile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }